import { useEffect } from 'react';

import SoundWave from '../SoundWave/SoundWave.js';

import './Header.css';

export default function Header(props) {
    return (
        <header style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/backgrounds/colorBars.png'})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%'}}>
            <SoundWave vid={props.soundWaveVid} waveDataUrl={process.env.PUBLIC_URL + '/video_wave_data/temp_video.json'}></SoundWave>
            <div className="items">
                <div className="item title">
                    <div className="title-container">
                        <a href="#">
                            <img src={process.env.PUBLIC_URL + '/title-logo.png'}></img>
                        </a>
                    </div>
                </div>
                <div className="item section-link"><a href="#music">MUSIC</a></div>
                <div className="item section-link"><a href="#events">EVENTS</a></div>
                <div className="item section-link"><a href="#about">ABOUT</a></div>
                <div className="item section-link"><a href="#follow">FOLLOW</a></div>
            </div>
        </header>
    )
}